import React from "react";
import { Redirect } from 'react-router-dom';

import LoginForm from '../../../components/Admin/LoginForm';
import { getAccessTokenApi } from '../../../api/auth';


export default function SignIn () {

    if (getAccessTokenApi()) {
        return <Redirect to="/admin" />
    }

    return (
        <div className="container-fluid login">
            <div className="row">
                <div className="col-6"></div>
                <div className="col-6 position-relative" style={{height: '100vh'}}>
                    <LoginForm />
                </div>
            </div>
        </div>
    )
}
